import { render, staticRenderFns } from "./CertificateApproval.vue?vue&type=template&id=55188f30&"
import script from "./CertificateApproval.vue?vue&type=script&lang=js&"
export * from "./CertificateApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports